import * as React from 'react'

import { excludeSkuFromProductUrls } from 'configuration/manifest'

import { NextPage } from '@grandvisionhq/next'
import {
  ErrorCase,
  InitialProps,
  Page,
  Props,
} from '@grandvisionhq/www-next/pages/product-detail/ready-readers'

import { composePDP } from '../../../components/hocs/compose-pdp'
import { getDeliveryIndicatorConfig } from '../../../configuration'

const ProductDetailPage: NextPage<Props, InitialProps | ErrorCase> = (props) => {
  const deliveryIndicatorConfig = getDeliveryIndicatorConfig()

  return <Page {...props} deliveryIndicatorConfig={deliveryIndicatorConfig} />
}

const getInitialProps = Page.getInitialProps
if (getInitialProps) {
  ProductDetailPage.getInitialProps = (ctx) =>
    getInitialProps({ ...ctx, pageConfig: { excludeSkuFromProductUrls } })
}

export default composePDP<Props>(ProductDetailPage)
